<template>
  <div>
    <b-card>
      <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
      </div>

      <b-row v-if="!loading">
        <b-col>
          <h3 class="m-0">
            {{ user.name }}
          </h3>
          <small class="text-muted">{{ user.email }}</small>
          <div class="small-dash-separator my-3"></div>

          <b-badge variant="info">{{ activity.log_name }}</b-badge>&nbsp;
          <b-badge>{{ activity.description }}</b-badge>

          <p class="text-dark font-weight-bold font-size-13 mb-1 mt-3">
            Created On:
            <span
              class="mb-3 text-body font-weight-normal"
            >{{ moment(new Date(activity.created_at)).format("DD MMM YYYY, HH:mm:ss") }}</span>
          </p>

          <div class="row mt-5">
            <div class="col-md-6">
              <b-card class="border p-2">
                <p class="text-dark font-weight-bold font-size-13">Changes</p>
                <pre class="text-body">{{ activity.properties | jsonPretty   }}</pre>
              </b-card>
            </div>
            <div class="col-md-6">
              <b-card class="border p-2">
                <p
                  class="text-dark font-weight-bold font-size-13"
                >{{ activity.log_name | capitalize }}</p>
                <pre class="text-body">{{ activity.subject | jsonPretty   }}</pre>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import userLogRepo from "@/api/repos/userLogRepo";

export default {
  props: ["id", "logId"],

  mounted() {
    this.getDetails();
  },

  data() {
    return {
      loading: false,
      activity: {},
      user: {},
    };
  },

  methods: {
    async getDetails() {
      try {
        this.loading = true;
        let { data } = await userLogRepo.details(this.id, this.logId);
        this.activity = data.activity;
        this.user = data.user;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
